@if (!reportsData?.real_sent_attacks_exist && reportsDataLoaded && [resilienceRoute, phishingTrendsRoute, campaignAnalyticsRoute].includes(router.url)) {
  <div class="pbi-report" [ngClass]="{'blue-bg': router.url !== resilienceRoute}">
    @if (router.url === resilienceRoute) {
      <div class="pbi-report-resilience">
        <div class="warning-message">
          <img src="assets/svg/warning_shield.svg">
          <span class="text">{{warningMessage}}</span>
        </div>
        <div class="charts-container">
          <div class="vertical-tiles">
            @if (reportsViewType === 1) {
              <div class="tile">
                <img src="assets/svg/res_no_employees.svg">
              </div>
              <div class="tile grey-bg"></div>
              <div class="tile grey-bg"></div>
              <div class="tile grey-bg"></div>
            }
            @if ([2, 3, 4].includes(reportsViewType)) {
              <div class="tile">
                <span class="value">{{reportsData?.details.employees}}</span>
                <span class="title">Employees</span>
              </div>
              <div class="tile">
                <span class="value">0</span>
                <span class="title">Attacks Sent</span>
              </div>
              <div class="tile">
                <span class="value">0</span>
                <span class="title">Unique Attacks</span>
              </div>
              <div class="tile">
                <span class="value">{{reportsData?.details.languages}}</span>
                <span class="title">Languages</span>
              </div>
            }
            @if (reportsViewType === 5) {
              <div class="tile grey-bg"></div>
              <div class="tile grey-bg"></div>
              <div class="tile grey-bg"></div>
              <div class="tile grey-bg"></div>
            }
          </div>
          <div class="horizontal-tiles">
            <div class="tile">
              <div class="item">
                <h2 class="item-header">Phishing Summary</h2>
                <div class="no-data-block">
                  <img src="assets/svg/charts-histogram.svg" alt="">
                  <h3>No Data @if (blastPurchased) {
                    Yet
                  }</h3>
                  <p>{{chartsMessage}}</p>
                </div>
              </div>
            </div>
            <div class="tile">
              <div class="item">
                <h2 class="item-header">Clicks Breakdown</h2>
                <div class="no-data-block">
                  <img src="assets/svg/charts-histogram.svg" alt="">
                  <h3>No Data @if (blastPurchased) {
                    Yet
                  }</h3>
                  <p>{{chartsMessage}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (router.url === campaignAnalyticsRoute) {
      <div class="pbi-report-campaign-analytics">
        <div class="warning-message">
          <img src="assets/svg/warning_shield.svg">
          <span class="text">{{warningMessage}}</span>
        </div>
        <div class="first-row">
          <div class="item">
            <h2 class="item-header">Campaign Data</h2>
            <div class="no-data-block">
              <img src="assets/svg/charts-histogram.svg" alt="">
              <h3>No Data @if (blastPurchased) {
                Yet
              }</h3>
              <p>{{chartsMessage}}</p>
            </div>
          </div>
          <div class="item">
            <h2 class="item-header">Location Data</h2>
            <div class="no-data-block">
              <img src="assets/svg/charts-histogram.svg" alt="">
              <h3>No Data @if (blastPurchased) {
                Yet
              }</h3>
              <p>{{chartsMessage}}</p>
            </div>
          </div>
        </div>
        <div class="second-row">
          <div class="item">
            <h2 class="item-header">Organizational Level Data</h2>
            <div class="no-data-block">
              <img src="assets/svg/charts-histogram.svg" alt="">
              <h3>No Data @if (blastPurchased) {
                Yet
              }</h3>
            </div>
          </div>
        </div>
      </div>
    }
    @if (router.url === phishingTrendsRoute) {
      <div class="pbi-report-phishing-trends">
        <div class="header ui-layout-row">
          <img src="assets/svg/phishing_trends_logo.svg">
          <h1>Phishing Trends</h1>
        </div>
        <div class="warning-message">
          <img src="assets/svg/warning_shield.svg">
          <span class="text">{{warningMessage}}</span>
        </div>
        <div class="phishing-row first-row">
          <div class="item">
            <h2 class="item-header">Click Rate over time</h2>
            <p class="item-description">Review click rate and benchmarks to make sure your program is on track</p>
            <div class="no-data-block">
              <img src="assets/svg/charts-histogram.svg" alt="">
              <h3>No Data @if (blastPurchased) {
                Yet
              }</h3>
              <p>{{chartsMessage}}</p>
            </div>
          </div>
          <div class="right-block">
            <div class="right-block-header">
              <img src="assets/svg/mouse.svg" alt="">
              <h3>How do I know my click rate is ok?</h3>
            </div>
            <p class="right-block-description">
              Click rate fluctuations reflect how the machine learning adapts to the employee performance in order to achieve the best employee-simulation fit.
              <br>Use the adaptive benchmark to know where you stand compared to others using the same simulations. Over time, employees will become more proficient at identifying phishing simulations and will click less but remember that clicking on phishing simulations is a good thing, as it signifies employees are getting trained. An ideal click rate would vary between 5-20% and as long as the high risk group is declining, positive click rates are good.
              </p>
            </div>
          </div>
          <div class="phishing-row second-row">
            <div class="column">
              <div class="item">
                <h2 class="item-header">Click Rate: New vs. Veteran Employees</h2>
                <p class="item-description">Comparing new employee performance to the rest of the organizations helps understand their risk contribution</p>
                <div class="no-data-block">
                  <img src="assets/svg/charts-histogram.svg" alt="">
                  <h3>No Data @if (blastPurchased) {
                    Yet
                  }</h3>
                  <p>{{chartsMessage}}</p>
                </div>
              </div>
              <div class="item">
                <h2 class="item-header">Number of New vs. Veteran Employees</h2>
                <p class="item-description">Consider employee turnover rate as this can impact performance</p>
                <div class="no-data-block">
                  <img src="assets/svg/charts-histogram.svg" alt="">
                  <h3>No Data @if (blastPurchased) {
                    Yet
                  }</h3>
                  <p>{{chartsMessage}}</p>
                </div>
              </div>
            </div>
            <div class="right-block">
              <div class="right-block-header">
                <img src="assets/svg/shield-exclamation-color.svg" alt="">
                <h3>Why is this metric important?</h3>
              </div>
              <p class="right-block-description">
                Employees are considered new until they have received the 7th simulation. On average, they tend to click twice as much as other employees however with continuous training, you will see that over time they will become proficient at identifying phishing simulations.
                <br><br>
                Tip: Consider enabling the new employees program to help get up to speed with the rest of the organization.
              </p>
            </div>
          </div>
          <div class="phishing-row third-row">
            <div class="item">
              <h2 class="item-header">Organization Break Down into Risk Groups</h2>
              <p class="item-description">Overtime expect the size of the low risk group to increase, as the size of the high risk group decreases</p>
              <div class="no-data-block">
                <img src="assets/svg/charts-histogram.svg" alt="">
                <h3>No Data @if (blastPurchased) {
                  Yet
                }</h3>
                <p>{{chartsMessage}}</p>
              </div>
            </div>
          </div>
          <div class="phishing-row fourth-row">
            <div class="item">
              <h2 class="item-header">Resilience Score</h2>
              <p class="item-description">Expect employees to have more success as they are trained with more simulations</p>
              <div class="no-data-block">
                <img src="assets/svg/charts-histogram.svg" alt="">
                <h3>No Data @if (blastPurchased) {
                  Yet
                }</h3>
                <p>{{chartsMessage}}</p>
              </div>
            </div>
            <div class="right-block">
              <div class="right-block-header">
                <img src="assets/svg/mouse.svg" alt="">
                <h3>What is the Resilience score?</h3>
              </div>
              <p class="right-block-description">
                The Resilience score is the average number of consecutive successes between two failed simulations. Expect to see that the longer employees train, the higher their Resilience score will be, indicating they fall for phishing less frequently. Note that even experienced employees fail once every six to ten simulations.
              </p>
            </div>
          </div>
        </div>
      }
    </div>
  }
